export const FORM_FIELDS_ERR_CONSTANTS: any = {
  termsConsent: {
    key: 'termsConsent',
    requiredError: 'Please accept the undertaking to proceed further',
  },
  pincode: {
    key: 'pincode',
    requiredError: 'This field is required',
  },
  businessAge: {
    key: 'businessAge',
    requiredError: 'This field is required',
  },
  incomeTurnover: {
    key: 'incomeTurnover',
    requiredError: 'This field is required',
  },
  annualIncome: {
    key: 'annualIncome',
    requiredError: 'Annual Income is required',
  },
  dob: {
    key: 'dob',
    requiredError: 'This field is required',
  },
  editEmail: {
    key: 'editEmail',
    requiredError: 'Email is required.',
    regexErr: 'Please enter a valid email',
  },
  annualTurnover: {
    key: 'annualTurnover',
    requiredError: 'Annual Turnover is required',
  },
  businessConstitution: {
    key: 'businessConstitution',
    requiredError: 'Business type is required',
  },
  employmentType: {
    key: 'employmentType',
    requiredError: 'Employment Type is required',
  },
  loanAmount: {
    key: 'loanAmount',
    requiredError: 'Loan amount is required',
  },
  houseOwnership: {
    key: 'houseOwnership',
    requiredError: 'Home Ownership is required',
  },
};

export const LOAN_TYPE = {
  personalLoan: 'PL',
  businessLoan: 'BL',
  homeLoan: 'HL',
  creditCard: 'CC',
  loanAgainstProperty: 'LAP',
  creditScore: 'CS',
};

export const CONTEXT_KEYS = {
  userCreditDetails: 'userCreditDetails',
  creditDetails: 'creditDetails',
};
